import InternationalNonConsolidation from '../international-non-consolidation';
import InternationalConsolidation from '../consolidation';
import { IFilterState, IQuotePrefill, IQuoteFormState } from '@helpers/types/quotes';

interface IInternationalQuote {
  quoteFormState: IQuoteFormState;
  setQuoteFormState: React.Dispatch<React.SetStateAction<IQuoteFormState>>;
  filterState: IFilterState;
  filterProductOptions: (event: any, param?: any) => Promise<void>;
  filterPorts: (event?: any, param?: any, fieldType?: string) => Promise<void>;
  data?: any;
  prefill?: IQuotePrefill | null;
  onSubmitClose: () => void;
  saveAsDraft: (reqBody: any) => Promise<void>;
  editEnquirySubmit: (enquiryId: string, reqBody: any) => Promise<void>;
  fetchFormCurrentValue: (data: any) => void;
}

const InternationalQuote = (props: IInternationalQuote) => {
  const {
    quoteFormState,
    setQuoteFormState,
    filterState,
    filterProductOptions,
    filterPorts,
    data,
    prefill,
    onSubmitClose,
    saveAsDraft,
    editEnquirySubmit,
    fetchFormCurrentValue
  } = props;

  const { consolidation } = filterState;

  return (
    <>
      {!consolidation ? (
        <InternationalNonConsolidation
          quoteFormState={quoteFormState}
          setQuoteFormState={setQuoteFormState}
          filterState={filterState}
          filterProductOptions={filterProductOptions}
          filterPorts={filterPorts}
          data={data}
          prefill={prefill}
          onSubmitClose={onSubmitClose}
          saveAsDraft={saveAsDraft}
          editEnquirySubmit={editEnquirySubmit}
          fetchFormCurrentValue={fetchFormCurrentValue}
        />
      ) : (
        <InternationalConsolidation
          quoteFormState={quoteFormState}
          setQuoteFormState={setQuoteFormState}
          filterState={filterState}
          filterProductOptions={filterProductOptions}
          filterPorts={filterPorts}
          data={data}
        />
      )}
    </>
  );
};

export default InternationalQuote;
